module.exports = __webpack_public_path__ + "img/title+@2x.d3ec5afa.png";